import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "container" }

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const mobileMenuOpen = ref(false)

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
}

const closeMobileMenu = () => {
  mobileMenuOpen.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              src: "/assets/img/logo.png",
              alt: "Space Coast STEM Logo",
              class: "logo-icon"
            }, null, -1),
            _createElementVNode("div", { class: "logo-text" }, [
              _createElementVNode("span", { class: "logo-space" }, "Space Coast"),
              _createElementVNode("span", { class: "logo-stem" }, "STEM")
            ], -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("ul", {
          class: _normalizeClass(["nav-menu", { active: mobileMenuOpen.value }])
        }, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/",
              onClick: closeMobileMenu
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("Home", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/about",
              onClick: closeMobileMenu
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("About", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/get-involved",
              onClick: closeMobileMenu
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Get Involved", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/students",
              onClick: closeMobileMenu
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Students", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/support",
              onClick: closeMobileMenu
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("Support", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/contact",
              onClick: closeMobileMenu
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("Contact", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/donate",
              class: "btn-donate",
              onClick: closeMobileMenu
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("Donate", -1)
              ]))]),
              _: 1
            })
          ])
        ], 2),
        _createElementVNode("div", {
          class: "hamburger",
          onClick: toggleMobileMenu
        }, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("span", null, null, -1),
          _createElementVNode("span", null, null, -1),
          _createElementVNode("span", null, null, -1)
        ]))])
      ])
    ])
  ]))
}
}

})